import Vue from 'vue';
import Component from 'vue-class-component';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import compose from 'lodash/fp/compose';

export const MOBILE_WIDTH = 479;
export const TABLET_PORTRAIT_WIDTH = 767;
export const TABLET_WIDTH = 1023;

export interface BreakPointChangePayload {
  newBreakpoint: string;
  oldBreakpoint: string;
  origin: Vue;
}

export type ViewportSize = 'desktop' | 'tablet' | 'tabletPortrait' | 'mobile' | string;

@Component
export default class ResizeUpdateMixin extends Vue {
  windowWidth = 0;
  windowHeight = 0;
  isResizeUpdateMixinInitialized = false;
  isMobile = true;
  isTablet = false;
  isTabletPortrait = false;
  isDesktop = false;
  viewportSize: ViewportSize = '';

  mounted () {
    this.resize();
    this.checkBreakpointChange();
    window.addEventListener(
      'resize',
      compose(throttle(this.resize, 300), debounce(this.resizeEnd, 300)),
      { passive: true },
    );
  }

  destroyed () {
    window.removeEventListener(
      'resize',
      compose(throttle(this.resize, 300), debounce(this.resizeEnd, 300)),
    );
  }

  private resize () {
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.isMobile = window.innerWidth <= MOBILE_WIDTH;
    this.isTabletPortrait = window.innerWidth > MOBILE_WIDTH && window.innerWidth <= TABLET_PORTRAIT_WIDTH;
    this.isTablet = window.innerWidth > MOBILE_WIDTH && window.innerWidth <= TABLET_WIDTH;
    this.isDesktop = window.innerWidth > TABLET_WIDTH;
    this.$emit('resize', { width: this.windowWidth, height: this.windowHeight });
    this.checkBreakpointChange();
    this.isResizeUpdateMixinInitialized = true;
  }

  private resizeEnd () {
    this.$emit('resizeEnd', { width: this.windowWidth, height: this.windowHeight });
  }

  private checkBreakpointChange () {
    if (this.isDesktop) {
      this.viewportSize = 'desktop';
    }
    if (this.isTablet) {
      this.viewportSize = 'tablet';
    }
    if (this.isTabletPortrait) {
      this.viewportSize = 'tabletPortrait';
    }
    if (this.isMobile) {
      this.viewportSize = 'mobile';
    }
  }
}
